import {
  StopoverDataExemptionPayloadType,
  StopoverPendencyFiltersType,
  StopoverPendencyResponseType,
} from '../types';
import { tosApi } from './tosApi';

const BASE_URL = '/maritime/stopover-pendencies';
// Alterações feitas no detalhe da escala (drawer) invalidam 'Stopover' e
// 'Docking' e recarregam o relatório; as isenções invalidam só o relatório.
const PENDENCIES_TAG = { type: 'Stopover' as const, id: 'PENDENCIES' };

export const stopoverPendencyApi = tosApi.injectEndpoints({
  endpoints: (build) => ({
    listStopoverPendencies: build.query<
      StopoverPendencyResponseType,
      StopoverPendencyFiltersType
    >({
      query: (params) => ({ url: BASE_URL, method: 'GET', params }),
      providesTags: () => [PENDENCIES_TAG, 'Docking'],
    }),
    createStopoverDataExemption: build.mutation<
      void,
      StopoverDataExemptionPayloadType
    >({
      query: (body) => ({
        url: `${BASE_URL}/exemptions`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, error) => (error ? [] : [PENDENCIES_TAG]),
    }),
    deleteStopoverDataExemption: build.mutation<
      void,
      StopoverDataExemptionPayloadType
    >({
      query: (params) => ({
        url: `${BASE_URL}/exemptions`,
        method: 'DELETE',
        params,
      }),
      invalidatesTags: (_result, error) => (error ? [] : [PENDENCIES_TAG]),
    }),
    // `file_format`: o backend não pode usar `format`, reservado pelo DRF.
    downloadStopoverPendencies: build.query<
      Blob,
      StopoverPendencyFiltersType & { file_format: 'xlsx' | 'csv' }
    >({
      query: (params) => ({
        url: `${BASE_URL}/export`,
        method: 'GET',
        params,
        cache: 'no-cache',
        responseHandler: (response: Response) => response.blob(),
      }),
      keepUnusedDataFor: 0,
    }),
    emailStopoverPendencies: build.query<void, StopoverPendencyFiltersType>({
      query: (params) => ({
        url: `${BASE_URL}/export`,
        method: 'GET',
        params: { ...params, delivery: 'email' },
        cache: 'no-cache',
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useListStopoverPendenciesQuery,
  useCreateStopoverDataExemptionMutation,
  useDeleteStopoverDataExemptionMutation,
  useLazyDownloadStopoverPendenciesQuery,
  useLazyEmailStopoverPendenciesQuery,
} = stopoverPendencyApi;
